import * as Sentry from "@sentry/react";

import { getHostnameInfo } from "~/app/utils";

const { hostname, client, product, environment } = getHostnameInfo();

Sentry.init({
  dsn: "https://cb14e0183fdd0f92d9b7cf4e6100428f@o366774.ingest.us.sentry.io/4509988899782656",
  enabled: !import.meta.env.DEV,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  tracesSampleRate: 1.0,
  environment,
  initialScope: {
    tags: { hostname, client, product },
  },
});
